import React from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../SearchBar';
import medicalProfessionals from '../../assets/images/medical-professionals.png';
import styles from './SearchSection.module.css';

const SearchSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.searchContainer} data-name="find a provider" id="node-12_9686">
      <div className="flex flex-col md:flex-row h-full max-w-[1600px] mx-auto">
        <div className={styles.imageContainer} data-name="Image container" id="node-12_9700">
          <div className="relative h-full w-full flex justify-center md:justify-end md:mr-8 overflow-hidden">
            <img
              src={medicalProfessionals}
              alt="Medical professionals providing quality healthcare services"
              className={styles.medicalImage}
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                console.warn('Failed to load medical professionals image');
              }}
            />
          </div>
        </div>

        <div className={styles.searchContentContainer} data-name="Search Section Container">
          <div
            className="w-full max-w-[500px] md:max-w-[676px]"
            data-name="Search Section"
            id="node-12_9688"
          >
            <div className="flex flex-col gap-6 md:gap-8">
              <div
                className="flex flex-col gap-3 md:gap-4"
                data-name="Search for a Provider"
                id="node-12_9689"
              >
                <h2 className={styles.searchTitle} id="node-12_9691">
                  Check a CLOUT score
                </h2>
                <p className={styles.searchDescription} id="node-12_9692">
                  Search for a provider, check CLOUT Scores and see who has endorsements.
                </p>
              </div>

              <div className="w-full">
                <SearchBar placeholder="Search a provider" isAuthenticated={false} />
              </div>

              <div className="flex" data-name="Search Button" id="node-12_9697">
                <button
                  onClick={() => navigate('/search')}
                  className={`${styles.browseButton} w-full sm:w-auto`}
                  data-name="Button"
                  id="node-12_9698"
                >
                  <span className={styles.browseButtonText} id="node-I12_9698-315_4669">
                    Browse Providers
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchSection;
